export default "__VITE_ASSET__BpaHHHg6__"